import { Modal, Form, Input, message } from "antd";
import { Supplier } from "@/types/supplier";
import { useUpdateExpenseSupplier } from "@/pages/Expenses/ManageExpense/hooks/useExpenseSuppliers";
import { useEffect } from "react";
import { UpdateExpenseSupplierFormValues } from "@/pages/Expenses/ManageExpense/api/expenseSuppliers";

const { TextArea } = Input;

interface EditModalProps {
  data?: Supplier;
  isOpen?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const EditModal = ({ data, isOpen, onClose, onSuccess }: EditModalProps) => {
  const [form] = Form.useForm();
  const { mutate: updateExpenseSupplier, isPending } =
    useUpdateExpenseSupplier();

  const handleSubmit = async (values: UpdateExpenseSupplierFormValues) => {
    const payload: UpdateExpenseSupplierFormValues = {
      ...values,
      id: data?.id || "",
    };

    updateExpenseSupplier(payload, {
      onSuccess: () => {
        message.success("Successfully updated expense supplier");
        form.resetFields();
        onClose?.();
        onSuccess?.();
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  useEffect(() => {
    if (!data) {
      return;
    }

    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <Modal
      title="Edit Supplier"
      open={isOpen}
      onCancel={handleCancel}
      width={600}
      confirmLoading={isPending}
      onOk={form.submit}
      okText="Update"
      destroyOnHidden
    >
      <Form<UpdateExpenseSupplierFormValues>
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={
          data && {
            name: data.name,
            contact_person: data.contact_person,
            email: data.email,
            phone: data.phone,
            address: data.address,
          }
        }
      >
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="contact_person" label="Contact Person">
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              type: "email",
              message: "Please enter a valid email",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="phone" label="Phone">
          <Input />
        </Form.Item>
        <Form.Item name="address" label="Address">
          <TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditModal;
